import type { TocMetaPerson } from "lib/types";

export function getPersonName(person: TocMetaPerson): string {
  return [person.First, person.Last].filter(Boolean).join(" ");
}
